import { MobDef } from '../mob';
import { BlockId } from '@shared/block-ids';

export const PIG_DEF: MobDef = {
  name: 'Pig',
  width: 0.5,
  height: 0.9,
  health: 10,
  speed: 1.5,
  hostile: false,
  color: 0xffaaaa,
  bodyColor: 0xee9999,
  detectionRange: 0,
  attackDamage: 0,
  attackRange: 0,
  drops: [
    { id: BlockId.BRICK, min: 1, max: 3 }, // porkchop placeholder (using brick)
  ],
};
